import React from 'react';

const ConstructionEquipment = () => {
  const equipmentTypes = [
    {
      id: 1,
      name: 'Excavator',
      price: '$250/day',
      features: ['Heavy Duty', '360° Rotation', 'Various Attachments', 'Operator Available'],
      image: '🏗️'
    },
    {
      id: 2,
      name: 'Trencher',
      price: '$180/day',
      features: ['Deep Trenching', 'Adjustable Depth', 'Fuel Efficient', 'Easy Transport'],
      image: '⛏️'
    },
    {
      id: 3,
      name: 'Bulldozer',
      price: '$300/day',
      features: ['Powerful Engine', 'Heavy Blade', 'Ripper Attachment', 'All Terrain'],
      image: '🚜'
    },
    {
      id: 4,
      name: 'Concrete Mixer',
      price: '$120/day',
      features: ['Portable', 'High Capacity', 'Electric Start', 'Durable Design'],
      image: '🔧'
    },
    {
      id: 5,
      name: 'Cement Pump',
      price: '$200/day',
      features: ['High Pressure', 'Long Reach', 'Easy Operation', 'Low Maintenance'],
      image: '💧'
    },
    {
      id: 6,
      name: 'Grader',
      price: '$280/day',
      features: ['Precision Leveling', 'Smooth Operation', 'Adjustable Blade', 'Road Ready'],
      image: '🛤️'
    }
  ];

  const handleBookNow = (equipmentName) => {
    // In a real app, this would navigate to booking page
    alert(`Booking ${equipmentName} - This would open the booking form`);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>XGO Construction Equipment</h1>
        <p style={styles.subtitle}>Professional equipment for your construction needs</p>
      </div>

      <div style={styles.equipmentGrid}>
        {equipmentTypes.map(equipment => (
          <div key={equipment.id} style={styles.equipmentCard}>
            <div style={styles.equipmentImage}>{equipment.image}</div>
            <h3 style={styles.equipmentName}>{equipment.name}</h3>
            <p style={styles.equipmentPrice}>{equipment.price}</p>
            <ul style={styles.featuresList}>
              {equipment.features.map((feature, index) => (
                <li key={index} style={styles.featureItem}>{feature}</li>
              ))}
            </ul>
            <button 
              style={styles.bookButton}
              onClick={() => handleBookNow(equipment.name)}
            >
              Book Now
            </button>
          </div>
        ))}
      </div>

      <div style={styles.infoSection}>
        <h2 style={styles.sectionTitle}>Why Choose XGO Construction Equipment?</h2>
        <div style={styles.benefits}>
          <div style={styles.benefit}>
            <h3 style={styles.benefitTitle}>🔧 Well Maintained</h3>
            <p style={styles.benefitText}>All equipment regularly serviced and in excellent condition</p>
          </div>
          <div style={styles.benefit}>
            <h3 style={styles.benefitTitle}>👨‍🔧 Expert Operators</h3>
            <p style={styles.benefitText}>Skilled operators available for all equipment types</p>
          </div>
          <div style={styles.benefit}>
            <h3 style={styles.benefitTitle}>🚚 Fast Delivery</h3>
            <p style={styles.benefitText}>Quick delivery to your construction site</p>
          </div>
          <div style={styles.benefit}>
            <h3 style={styles.benefitTitle}>⏰ 24/7 Support</h3>
            <p style={styles.benefitText}>Round-the-clock technical assistance</p>
          </div>
        </div>
      </div>

      <div style={styles.contactSection}>
        <h2 style={styles.contactTitle}>Need Help?</h2>
        <p style={styles.contactText}>Call us: +260 123 456 789</p>
        <p style={styles.contactText}>Email: equipment@xgo.com</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f8f9fa'
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    backgroundColor: '#FF6B35',
    color: 'white',
    padding: '30px',
    borderRadius: '10px'
  },
  title: {
    fontSize: '2.5rem',
    margin: '0',
    marginBottom: '10px'
  },
  subtitle: {
    fontSize: '1.2rem',
    margin: '0',
    opacity: 0.9
  },
  equipmentGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    marginBottom: '40px'
  },
  equipmentCard: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    textAlign: 'center',
    transition: 'transform 0.3s ease'
  },
  equipmentImage: {
    fontSize: '4rem',
    marginBottom: '15px'
  },
  equipmentName: {
    fontSize: '1.5rem',
    margin: '0 0 10px 0',
    color: '#333'
  },
  equipmentPrice: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: '#FF6B35',
    margin: '0 0 15px 0'
  },
  featuresList: {
    listStyle: 'none',
    padding: '0',
    margin: '0 0 20px 0',
    textAlign: 'left'
  },
  featureItem: {
    backgroundColor: '#f8f9fa',
    padding: '5px 10px',
    margin: '5px 0',
    borderRadius: '5px',
    fontSize: '0.9rem'
  },
  bookButton: {
    backgroundColor: '#FF6B35',
    color: 'white',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '5px',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    fontWeight: 'bold'
  },
  infoSection: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '10px',
    marginBottom: '30px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  },
  sectionTitle: {
    fontSize: '2rem',
    color: '#333',
    textAlign: 'center',
    marginBottom: '30px'
  },
  benefits: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px'
  },
  benefit: {
    textAlign: 'center',
    padding: '20px'
  },
  benefitTitle: {
    fontSize: '1.3rem',
    color: '#FF6B35',
    marginBottom: '10px'
  },
  benefitText: {
    color: '#666',
    lineHeight: '1.5'
  },
  contactSection: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '10px'
  },
  contactTitle: {
    color: '#333',
    marginBottom: '15px'
  },
  contactText: {
    color: '#666',
    margin: '5px 0',
    fontSize: '1.1rem'
  }
};

export default ConstructionEquipment;
